/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Logo from "../../assets/images/auth/Logo.svg";
import { RootState } from "../../redux/store";
import { useNavigate } from "react-router-dom";
import { AuthAPIS } from "../../api/LoginApi";
import { Toast } from "primereact/toast";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { Button } from "primereact/button";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
interface UserDetails extends JwtPayload {
  displayName: string;
  exp: number;
  iat: number;
  roleID: number;
  roleName: string;
  userEmail: string;
  userID: number;
}
const Login: React.FC = () => {
  const [authApi] = useState<AuthAPIS>(new AuthAPIS());
  const [userEmail, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useRef<Toast>(null);

  const { error } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate(localStorage.currentModuleUrl);
    }
  }, []);

  const setItemInLocalStorage = (key: string, value: string) => {
    if (key === "moduleID" && userEmail === "jakub@ameliogroup.co.uk") {
      localStorage.setItem(key, value + ",2");
    } else {
      localStorage.setItem(key, value);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoading(true);
    await authApi
      .login(userEmail, password)
      .then((data) => {
        localStorage.setItem("token", data.data.loginUser.access_token);
        const userDetails: UserDetails = jwtDecode<UserDetails>(
          localStorage.getItem("token") || ""
        );

        // localStorage.setItem("roleDisplayNames", JSON.stringify([userDetails.roleName]));

        Object.keys(userDetails).forEach((key) => {
          setItemInLocalStorage(key, (userDetails as Record<string, any>)[key]);
        });
        showSuccess(); // Show success toast
        navigate("/layout/select-module");
      })
      .catch((err) => {
        setLoading(false);
        showError(err.status, err?.response?.data?.Message); // Show  Error
      }); // Use actual userEmail and password
    setLoading(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const showSuccess = () => {
    toast.current?.show({
      severity: "success",
      summary: "Success",
      detail: "Login Successfull",
      life: 3000,
    });
  };
  const showError = (statusCode: number, message?: string) => {
    toast.current?.show({
      severity: "error",
      summary: "Login Failed",
      detail: message
        ? message
        : statusCode === 400 || statusCode === 401
        ? "Invalid credentials, please try again"
        : "Something Went Wrong, Please try again",
      life: 3000,
    });
  };

  return (
    <div className="login-container">
      <Toast ref={toast} /> {/* Toast component */}
      <div className="login-left">
        <div className="logo-wrapper">
          <img
            src={Logo}
            alt="logo"
            width="450"
            height="450"
            style={{ marginTop: "0%" }}
          />
        </div>
      </div>
      <div className="login-right">
        <div className="login-form">
          <h2>Log in to your account</h2>
          <p>Welcome back! Please enter your details.</p>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className="input-group tw-mt-[42px]">
              <FloatLabel>
                <InputText
                  id="email"
                  value={userEmail}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <label htmlFor="email">Email *</label>
              </FloatLabel>
            </div>
            <div className="input-group tw-relative">
              <FloatLabel>
                <InputText
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <label htmlFor="username">Password *</label>
              </FloatLabel>
              <span
                onClick={togglePasswordVisibility}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "16px",
                  cursor: "pointer",
                  color: "#999",
                }}
              >
                <i
                  className={showPassword ? "pi pi-eye" : "pi pi-eye-slash"}
                ></i>
              </span>
            </div>
            <button
              type="submit"
              className="login-button tw-mt-0"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Sign in"}
            </button>
          </form>
          <div className="tw-text-center tw-mt-4 tw-font-semibold tw-leading-5 tw-text-[#555555]">
            <Button
              label="Forgot Password"
              icon="pi pi-angle-right"
              onClick={() => navigate("/forgot-password")}
              iconPos="right"
              link
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
